import { render, staticRenderFns } from "./Masslist.vue?vue&type=template&id=0df25011&scoped=true"
import script from "./Masslist.vue?vue&type=script&lang=js"
export * from "./Masslist.vue?vue&type=script&lang=js"
import style0 from "./Masslist.vue?vue&type=style&index=0&id=0df25011&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df25011",
  null
  
)

export default component.exports